import { render, staticRenderFns } from "./LoaderComponent.vue?vue&type=template&id=581671c8&scoped=true&"
import script from "./LoaderComponent.vue?vue&type=script&lang=js&"
export * from "./LoaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoaderComponent.vue?vue&type=style&index=0&id=581671c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581671c8",
  null
  
)

export default component.exports